import { Body } from 'app/components/Typography';
import { ReservationEditButton } from 'app/components/ReservationEditButton';
import { selectglobalSettings } from 'app/slice/selectors';
import { translations } from 'locales/translations';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { dateUtils } from 'utils/date-utils';
import { AllowedSettings } from 'utils/globalSettings';
import { isNullOrUndefined } from 'utils/typeUtils';
import { WorkOrderReadonlyState } from '../slice/types';
import styled from 'styled-components';

export interface CreationDetailsProps {
  details: WorkOrderReadonlyState;
}

export function CreationDetails(props: CreationDetailsProps) {
  const { details } = props;
  const globalSettings = useSelector(selectglobalSettings);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <DetailsWrapper className={'readonly-root'}>
        <Body bold={true}>{t(translations.WorkOrderAdvancedDetails)}</Body>
        <div className={'readonly-content'}>
          <div className={'readonly-row'}>
            <Body size="small">{t(translations.ReportedBy)}</Body>
            <Body size="small" bold={true}>
              {details.ReportedByDisplayName}
            </Body>
          </div>
          <div className={'readonly-row'}>
            <Body size="small">{t(translations.ReportedDate)}</Body>
            <Body size="small" bold={true}>
              {dateUtils.longDateTimeFormat(details.CreateDate)}
            </Body>
          </div>
          <div className={'readonly-row'}>
            <Body size="small">{t(translations.LastUpdated)}</Body>
            <Body size="small" bold={true}>
              {dateUtils.longDateTimeFormat(details.LastUpdated) ?? 'N/A'}
            </Body>
          </div>
          <div className={'readonly-row'}>
            <Body size="small">{t(translations.AlertType)}</Body>
            <Body size="small" bold={true}>
              {details.AlertType ?? 'N/A'}
            </Body>
          </div>
          <div className={'readonly-row'}>
            <Body size="small">{t(translations.EventTypeStatus)}</Body>
            <Body size="small" bold={true}>
              {details.StatusName ?? 'N/A'}
            </Body>
          </div>
          <div className={'readonly-row'}>
            <Body size="small">{t(translations.ClosedAt)}</Body>
            <Body size="small" bold={true}>
              {dateUtils.longDateTimeFormat(details.DoneDate) ||
                t(translations.WorkStillInProgress)}
            </Body>
          </div>
          <div className={'readonly-row'}>
            <Body size="small">{t(translations.ClosedBy)}</Body>
            <Body size="small" bold={true}>
              {details.DoneBy ?? 'N/A'}
            </Body>
          </div>
          {details.Reservation !== null && (
            <div className={'readonly-row'}>
              <Body size="small">{t(translations.Reservation)}</Body>
              <ReservationEditButton
                reservationId={details.Reservation}
                variant="text"
              >
                {`# ${details.Reservation}`}
              </ReservationEditButton>
            </div>
          )}
          {globalSettings.GetBooleanByKey(AllowedSettings.AssetCatEnabled) &&
            !isNullOrUndefined(details.AssetCatName) && (
              <div className={'readonly-row'}>
                <Body size="small">{t(translations.AssetCatName)}</Body>
                <Body size="small" bold={true}>{`${details.AssetCatName} - ${
                  details.InternalServiceAvaliable
                    ? t(translations.InternalServiceAvaliable)
                    : ''
                }`}</Body>
              </div>
            )}
        </div>
      </DetailsWrapper>
    </React.Fragment>
  );
}
const DetailsWrapper = styled.div`
  &.readonly-root {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    grid-gap: 4px;
    padding: 0;
    width: 100%;
  }
  & .readonly-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    grid-gap: 16px;
    padding: 16px 0px;
    width: 100%;
  }
  & .readonly-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    width: inherit;
  }
`;
